import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const blocks = [{
  imagePosition: "left",
  subtitle: "THE BEGINNING",
  title: "A Chance Encounter",
  text: "It all started on a crisp autumn evening in London. Anthony and Lily first crossed paths at a small bookstore in Notting Hill, both reaching for the same vintage edition of a classic novel. What began as a polite apology quickly turned into a three-hour conversation over coffee. They discovered a shared love for old architecture, jazz music, and the simple beauty of a rainy afternoon, marking the start of a journey neither of them expected but both deeply desired.",
  buttonText: "Our Full Story",
  buttonLink: "/OurStoryPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/couple_bookstore.png"
}, {
  imagePosition: "right",
  subtitle: "THE JOURNEY",
  title: "Building a Life Together",
  text: "Over the next four years, their relationship blossomed through shared adventures and quiet moments alike. From hiking the rugged cliffs of the Amalfi Coast to the simple joy of cooking Sunday dinners in their first shared apartment, every experience strengthened their bond. They learned that love isn't just about the grand gestures, but about the unwavering support and laughter found in the everyday rhythm of life, creating a foundation built on trust and mutual respect.",
  buttonText: "View Our Gallery",
  buttonLink: "/GalleryPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_lily_travels.png"
}, {
  imagePosition: "left",
  subtitle: "THE PROPOSAL",
  title: "A Promise for Forever",
  text: "Under a canopy of stars during a weekend getaway to the countryside, Anthony asked Lily to spend the rest of her life with him. It was a moment of pure magic, reflecting the quiet elegance and deep sincerity of their love. Now, as they prepare to say 'I do,' they invite you to join them in celebrating the next chapter of their story. This celebration is not just about a wedding, but about the beautiful life they are continuing to build together.",
  buttonText: "Event Details",
  buttonLink: "/TheBigDayPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_lily_proposal.png"
}];
export default function IntroductionBlock() {
  return <section data-section-id="261363" id="how-it-all-began" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 flex flex-col gap-16 md:gap-24">
        {blocks.map((block, i) => <div key={i} data-index={i} className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {}
            <div className={`w-full ${block.imagePosition === "right" ? "order-1 lg:order-2" : "order-1"}`}>
              <div className="relative w-full aspect-[4/3] overflow-hidden rounded-md bg-muted shadow-md">
                <img src={block.imageSrc} data-wvc-srcset={`${block.imageSrc}-wvc-srcset`} data-wvc-sizes={`${block.imageSrc}-wvc-sizes`} alt={block.title || "Anthony and Lily"} className="w-full h-full object-cover" loading="lazy" />
              </div>
            </div>

            {}
            <div className={`flex flex-col items-start ${block.imagePosition === "right" ? "order-2 lg:order-1" : "order-2"}`}>
              {block.subtitle && <span className="text-sm font-default tracking-widest text-primary uppercase mb-4">
                  {block.subtitle}
                </span>}
              {block.title && <h2 className="text-4xl md:text-5xl font-default text-foreground mb-6 tracking-tight">
                  {block.title}
                </h2>}
              <p className="text-muted-foreground leading-relaxed text-lg mb-8 font-serif">
                {block.text}
              </p>
              <Button asChild size="lg" className="rounded-md bg-primary text-primary-foreground hover:opacity-90 transition-opacity shadow-sm">
                
              </Button>
            </div>
          </div>)}
      </div>
    </section>;
}